import type { PaperProps as MuiPaperProps } from '@mui/material/Paper/Paper';
import MuiPaper from '@mui/material/Paper/Paper';

export type PaperProps = MuiPaperProps;

export const Paper = MuiPaper;
